export default __webpack_public_path__ + "static/media/be3d64a218f9885c.79338e6ce161dc2877d9ffce2bf01870.svg";